import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, uaeProjectsBaseURL } from './../../../../Containers/Config/index';
import { CREATE_VENDOR, CREATE_VENDOR_SUCCESS, CREATE_VENDOR_ERROR } from './../../actionType';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* createVendor({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/admin/categories`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response?.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_VENDOR_ERROR, payload: error });
  }
}

export function* watchCreateVendorSaga() {
  yield takeEvery(CREATE_VENDOR, createVendor);
}

function* createVendorSaga() {
  yield all([fork(watchCreateVendorSaga)]);
}

export default createVendorSaga;
